/* Nukebox Insights — storefront events, active time, consent, Clarity tags, Ask launcher.
 * Plain script, no build step. Does nothing unless #nkx-insights-config exists.
 * Identifiers are anonymous and minted here; nothing identifying a person is sent. */
(function () {
  'use strict';
  var cfgEl = document.getElementById('nkx-insights-config');
  if (!cfgEl || window.__nkxInsights) return;
  var cfg; try { cfg = JSON.parse(cfgEl.textContent || '{}'); } catch (e) { return; }
  var API = String(cfg.api || '').replace(/\/$/, '');
  if (!API) return;

  /* ── ids ─────────────────────────────────────────────────────────────── */
  function rnd(n) { var a = new Uint8Array(n); (window.crypto || window.msCrypto).getRandomValues(a); return Array.prototype.map.call(a, function (b) { return ('0' + b.toString(16)).slice(-2); }).join(''); }
  function store(kind) { try { return kind === 'local' ? window.localStorage : window.sessionStorage; } catch (e) { return null; } }
  function get(kind, k) { var s = store(kind); try { return s ? s.getItem(k) : null; } catch (e) { return null; } }
  function set(kind, k, v) { var s = store(kind); try { if (s) s.setItem(k, v); } catch (e) { /* private mode */ } }
  function cookie(name, value, maxAge) { try { document.cookie = name + '=' + encodeURIComponent(value) + '; path=/; max-age=' + maxAge + '; SameSite=Lax; Secure'; } catch (e) { /* ignore */ } }

  var SESSION_IDLE_MS = 30 * 60 * 1000;
  var now = Date.now();
  var vid = get('local', 'nkx_vid'); if (!vid || !/^[a-f0-9]{24}$/.test(vid)) { vid = rnd(12); set('local', 'nkx_vid', vid); }
  var sid = get('session', 'nkx_sid'); var sidAt = Number(get('session', 'nkx_sid_at') || 0);
  if (!sid || !/^[a-f0-9]{24}$/.test(sid) || now - sidAt > SESSION_IDLE_MS) { sid = rnd(12); }
  set('session', 'nkx_sid', sid); set('session', 'nkx_sid_at', String(now));
  var plid = rnd(6);

  /* ── campaign context (anonymous UTM identifiers only) ───────────────── */
  var qs = new URLSearchParams(window.location.search);
  function clean(v) { if (!v) return null; v = String(v).trim().slice(0, 80); if (!v || /@|(?:\+?\d[\s-]?){8,}/.test(v)) return null; return v; }
  var utm = null;
  if (qs.get('utm_campaign')) {
    utm = { campaign: clean(qs.get('utm_campaign')), creative: clean(qs.get('utm_content')), source: clean(qs.get('utm_source')), medium: clean(qs.get('utm_medium')) };
    set('session', 'nkx_utm', JSON.stringify(utm));
    if (!get('local', 'nkx_first_utm')) set('local', 'nkx_first_utm', JSON.stringify({ at: now, utm: utm }));
  } else { try { utm = JSON.parse(get('session', 'nkx_utm') || 'null'); } catch (e) { utm = null; } }
  var device = (function () { var w = Math.min(window.screen.width, window.innerWidth || 9999); var touch = 'ontouchstart' in window; if (touch && w < 768) return 'mobile'; if (touch && w < 1100) return 'tablet'; return 'desktop'; })();

  /* The custom pixel runs in a sandbox with its own storage but shares cookies. */
  cookie('_nkx_sid', sid, 1800); cookie('_nkx_vid', vid, 86400 * 400);
  cookie('_nkx_ctx', [utm && utm.campaign || '', utm && utm.creative || '', utm && utm.source || '', utm && utm.medium || '', device].join('|'), 1800);

  /* ── consent (Shopify Customer Privacy API) ─────────────────────────── */
  var consent = null; // null = not yet known; Shopify defaults to allowed outside consent regions
  function applyClarityConsent() {
    if (typeof window.clarity !== 'function' || consent === null) return;
    try { window.clarity('consentv2', { ad_Storage: consent ? 'granted' : 'denied', analytics_Storage: consent ? 'granted' : 'denied' }); } catch (e) { /* ignore */ }
  }
  function readConsent() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function') { consent = !!cp.analyticsProcessingAllowed(); }
    } catch (e) { /* ignore */ }
    applyClarityConsent();
    if (consent === false) queue.length = 0;
  }
  try {
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], function (err) { if (!err) readConsent(); else { consent = true; applyClarityConsent(); } });
    } else { consent = true; }
  } catch (e) { consent = true; }
  document.addEventListener('visitorConsentCollected', function (e) {
    consent = !!(e && e.detail && (e.detail.analyticsAllowed || e.detail.analyticsProcessingAllowed));
    applyClarityConsent();
    if (!consent) queue.length = 0;
  });

  /* ── queue + transport ──────────────────────────────────────────────── */
  var queue = []; var timer = null; var seq = 0;
  function batch() {
    return { v: 1, source: 'theme', session_id: sid, visitor_id: vid, device: device, consent_analytics: consent,
      campaign: utm && utm.campaign || null, creative: utm && utm.creative || null, utm_source: utm && utm.source || null, utm_medium: utm && utm.medium || null, events: queue.splice(0, 25) };
  }
  function send(useBeacon) {
    if (!queue.length || consent === false) return;
    var body = JSON.stringify(batch());
    var url = API + '/api/public/nukebox/events';
    try {
      if (useBeacon && navigator.sendBeacon) { navigator.sendBeacon(url, new Blob([body], { type: 'text/plain' })); return; }
      fetch(url, { method: 'POST', headers: { 'content-type': 'application/json' }, body: body, keepalive: true, mode: 'cors', credentials: 'omit' })
        .then(function (r) { return r.json(); }).then(function (j) { if (j && j.rejected && j.rejected.length && window.console) console.warn('[nkx-insights] rejected events', j.rejected); }).catch(function () { /* analytics never breaks the page */ });
    } catch (e) { /* ignore */ }
  }
  function schedule() { if (timer) return; timer = setTimeout(function () { timer = null; send(false); }, 2500); }
  function track(name, props, extra) {
    extra = extra || {};
    seq += 1;
    queue.push({
      name: name,
      occurred_at: new Date().toISOString(),
      dedupe_key: extra.dedupe || (sid + ':' + plid + ':' + name + (extra.suffix ? ':' + extra.suffix : '')),
      page_type: cfg.page.type, page_path: cfg.page.path,
      product_handle: extra.productHandle !== undefined ? extra.productHandle : cfg.page.productHandle,
      variant_id: extra.variantId !== undefined ? extra.variantId : (cfg.page.variantId ? String(cfg.page.variantId) : null),
      properties: props || {}
    });
    if (window.clarity && /add_to_cart|chat_opened|wallpaper_download|sharing_faq_opened/.test(name)) { try { window.clarity('event', name); } catch (e) { /* ignore */ } }
    schedule();
  }
  window.addEventListener('pagehide', function () { flushActive(); send(true); });
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') { flushActive(); send(true); } });

  /* ── Clarity tags (consent-aware; Clarity itself masks inputs) ──────── */
  if (window.clarity) {
    try {
      if (utm && utm.campaign) window.clarity('set', 'nkx_campaign', utm.campaign);
      if (utm && utm.creative) window.clarity('set', 'nkx_creative', utm.creative);
      window.clarity('set', 'nkx_device', device);
      if (cfg.page.productHandle) window.clarity('set', 'nkx_product', cfg.page.productHandle);
    } catch (e) { /* ignore */ }
    applyClarityConsent();
  }

  /* ── page + product ─────────────────────────────────────────────────── */
  var refHost = ''; try { refHost = document.referrer ? new URL(document.referrer).hostname : ''; } catch (e) { /* ignore */ }
  track('page_view', { title: String(cfg.page.title || '').slice(0, 120), referrer_host: refHost });
  if (cfg.page.type === 'product' && cfg.page.productHandle) {
    track('product_viewed', { price: cfg.page.price ? String(cfg.page.price) : null, currency: cfg.page.currency || null });
  }

  /* ── add to cart: any product form posting to /cart/add ─────────────── */
  document.addEventListener('submit', function (e) {
    var form = e.target; if (!form || !form.getAttribute) return;
    var action = form.getAttribute('action') || '';
    if (!/\/cart\/add/.test(action)) return;
    var idInput = form.querySelector('input[name="id"], select[name="id"]');
    var variant = idInput && idInput.value ? String(idInput.value) : null;
    var qtyInput = form.querySelector('input[name="quantity"]');
    var handle = cfg.page.productHandle;
    if (!handle) { var card = form.closest('[data-product-handle]') || form.closest('.nks-card'); var a = card && card.querySelector('a[href*="/products/"]'); if (a) { var m = a.getAttribute('href').match(/\/products\/([a-z0-9-]+)/); if (m) handle = m[1]; } }
    track('add_to_cart', { quantity: qtyInput ? Number(qtyInput.value) || 1 : 1, price: cfg.page.price ? String(cfg.page.price) : null, currency: cfg.page.currency || null },
      { dedupe: sid + ':add_to_cart:' + (variant || 'na') + ':' + Math.floor(Date.now() / 10000), productHandle: handle, variantId: variant });
  }, true);

  /* ── the sharing explanation on the PDP (there is no video demo) ────── */
  var faq = document.getElementById('pdp-faq');
  if (faq && 'IntersectionObserver' in window) {
    var dwell = null, seen = false;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.intersectionRatio >= 0.5 && !seen) { dwell = dwell || setTimeout(function () { seen = true; io.disconnect(); track('faq_section_visible', {}); }, 1000); }
        else if (dwell && en.intersectionRatio < 0.5) { clearTimeout(dwell); dwell = null; }
      });
    }, { threshold: [0, 0.5, 1] });
    io.observe(faq);
    Array.prototype.forEach.call(faq.querySelectorAll('details'), function (d) {
      var s = d.querySelector('summary'); if (!s) return;
      if (/send photos from anywhere|from abroad|other (cities|countries)/i.test(s.textContent || '')) {
        d.addEventListener('toggle', function () { if (d.open) track('sharing_faq_opened', {}); });
      }
    });
  }

  /* ── active time: visible + focused + interacted within 30 s ────────── */
  var lastActivity = Date.now(); var activeSeconds = 0; var tickIndex = 0; var focused = document.hasFocus();
  ['pointerdown', 'pointermove', 'keydown', 'scroll', 'touchstart', 'wheel'].forEach(function (ev) { window.addEventListener(ev, function () { lastActivity = Date.now(); }, { passive: true }); });
  window.addEventListener('focus', function () { focused = true; }); window.addEventListener('blur', function () { focused = false; });
  setInterval(function () {
    if (document.visibilityState !== 'visible' || !focused) return;
    if (Date.now() - lastActivity > 30000) return;
    activeSeconds += 1;
    if (activeSeconds >= 15) flushActive();
  }, 1000);
  function flushActive() {
    if (activeSeconds <= 0) return;
    tickIndex += 1;
    track('active_time', { seconds: Math.min(60, activeSeconds) }, { suffix: String(tickIndex) });
    activeSeconds = 0;
  }

  /* ── wallpapers: mirror the page's own Shopify custom events ────────── */
  if (cfg.page.type === 'wallpapers' && window.Shopify && window.Shopify.analytics) {
    var orig = window.Shopify.analytics.publish; var counters = {};
    window.Shopify.analytics.publish = function (name, p) {
      try {
        if (/^(wallpaper_download|wallpaper_frame_preview|wallpaper_shop_click)$/.test(name)) {
          var key = name + ':' + (p && p.wallpaper_handle || '') + ':' + (p && p.frame || '');
          counters[key] = (counters[key] || 0) + 1;
          var props = { wallpaper_handle: p && p.wallpaper_handle || null, wallpaper_category: p && p.wallpaper_category || null };
          if (name === 'wallpaper_frame_preview') props = { frame: p && p.frame || null, wallpaper_handle: p && p.wallpaper_handle || null };
          if (name === 'wallpaper_shop_click') props = { wallpaper_handle: p && p.wallpaper_handle || null };
          track(name, props, { dedupe: sid + ':' + plid + ':' + key + ':' + counters[key], productHandle: null, variantId: null });
        }
      } catch (e) { /* ignore */ }
      return typeof orig === 'function' ? orig.apply(this, arguments) : undefined;
    };
  }

  /* ── Ask Nukebox: lazy, pilot pages only, both switches on ──────────── */
  window.__nkxInsights = { track: track, ids: function () { return { sid: sid, vid: vid, plid: plid }; }, ctx: function () { return { utm: utm, device: device, consent: consent, page: cfg.page, api: API, surface: cfg.askSurface }; } };
  if (cfg.ask && cfg.askHere && cfg.assets && cfg.assets.ask) {
    var loadAsk = function () {
      if (document.getElementById('nkx-ask-script')) return;
      var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = cfg.assets.askCss; document.head.appendChild(l);
      var s = document.createElement('script'); s.id = 'nkx-ask-script'; s.src = cfg.assets.ask; s.defer = true; document.body.appendChild(s);
    };
    if ('requestIdleCallback' in window) window.requestIdleCallback(loadAsk, { timeout: 3000 }); else setTimeout(loadAsk, 1500);
  }
})();
